async function OilerSave(oilerid, jobnum, numtestpoints, infeedsensordistance, siteaddress, createdbyid, notes) {

    if (true) {

        let response;

        let params = {
            "@OilerID": oilerid,
            "@JobNum": jobnum,
            "@NumTestPoints": numtestpoints,
            "@InfeedSensorDistance": infeedsensordistance,
            "@SiteAddress": siteaddress,
            "@CreatedByID": createdbyid,
            "@Notes": notes
        };

        response = await fetch("https://api.cssi.co/query", {
            method: "POST",
            body: JSON.stringify({
                "sp": "100",
                "parameters": params,
                "servername": "Compass-Svr3\\EXACTSQLEXPRESS",
                "databasename": "WebApps",
                "continuingfunction": null,
                "noresults": false,
                "args": null
            })
        })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);
            })

        return Promise.resolve(response);

    }
}

export default OilerSave;